import styled from "styled-components";
import { BodySmall, HeadLine3 } from "../../../../components/typography/styled";
export const Container = styled.div`
  display: grid;
  grid-template-columns: repeat(6, minmax(0, 1fr));
  width: 100%;
  margin-top:20px;
  gap:10px;

  @media screen and (max-width: 900px) {
    grid-template-columns: repeat(3, minmax(0, 1fr));
    align-items: stretch;
  }

  @media screen and (max-width: 768px) {
    gap: 8px;
    margin-top: 12px;
  }

  @media screen and (max-width: 600px) {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

`

export const DiagramWrapper = styled.div`
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  /* margin-right:10px;
  margin-bottom:10px; */
  padding: 28px 15px;
  min-height: 199px;
  min-width: 0;
  width: 100%;
  max-width: 100%;
  background-color: ${({theme}) => theme.palette[10]};
  border-radius:14px;
  box-shadow: 0 4px 30px rgba(186, 196, 211, 0.2);
  /* &:hover {
    cursor: pointer;
    background: ${({theme}) => theme.isDark ? theme.palette[200] : theme.grey[100]};
  } */
  /* &:active{
    background-color: ${({theme}) => theme.isDark ? theme.palette[400] : theme.grey[200]};
    transition: 0.1s background-color ease-in-out;
  } */

  @media screen and (max-width: 900px) {
    min-width: 0;
  }

  @media screen and (max-width: 768px) {
    min-height: 84px;
    height: auto;
    padding: 10px;
    flex-direction: row;
    align-items: center;
    text-align: left;
    gap: 10px;
  }

`

export const DiagramContent = styled.div`
  display: flex;
  min-width: 0;
  flex-direction: column;
  align-items: center;

  @media screen and (max-width: 768px) {
    flex: 1;
    align-items: flex-start;
    gap: 2px;
  }
`

export const DiagramName = styled(HeadLine3)`
  color:${({theme}) => theme.neutral[100]};
  margin-top:10px;

  @media screen and (max-width: 768px) {
    margin-top: 0;
    font-size: 14px;
    line-height: 18px;
  }
`
export const Description = styled(BodySmall)`
  color:${({theme}) => theme.neutral[80]};
  margin-top:6px;
  white-space: normal;

  @media screen and (max-width: 768px) {
    margin-top: 0;
    white-space: normal;
    overflow-wrap: anywhere;
    font-size: 12px;
    line-height: 16px;
  }
`

export const Pie = styled.div`
  border-radius : 4px;
  width: 82px;
  min-width: 82px;
  height: 82px;
  min-height: 82px;
  flex: 0 0 82px;
  aspect-ratio: 1;
  display: inline-grid;
  place-content: center;
  margin: 0;
  border-radius: 50%;
  font-size: 25px;
  font-weight: bold;
  font-family: sans-serif;
  position: relative;
  overflow: hidden;
  transition:
    --quota-used var(--quota-duration, 0ms) cubic-bezier(0.22, 1, 0.36, 1),
    --quota-rotation var(--quota-duration, 0ms) cubic-bezier(0.22, 1, 0.36, 1);

  background: ${({theme}) => theme.isDark
    ? 'linear-gradient(180deg, #535353 0%, #747474 100%)'
    : 'linear-gradient(180deg, #D2E9FF 0%, #F0F5FF 100%)'};
  &:before {
    content: "";
    position: absolute;
    border-radius: 50%;
    inset: 0;
    background: ${({theme}) => theme.isDark
      ? '#6288FF'
      : 'linear-gradient(120deg, #BBE3FF 1.442%, #0B6AEF 75.962%)'};
    -webkit-mask: conic-gradient(#000 var(--quota-used, 0%), transparent 0);
    mask: conic-gradient(#000 var(--quota-used, 0%), transparent 0);
    transition: 0s all ease-in-out;
  }

  @media screen and (max-width: 768px) {
    width: 42px;
    min-width: 42px;
    height: 42px;
    min-height: 42px;
    flex-basis: 42px;
  }
`

export const PieBorder = styled.div`
  position: absolute;
  top: 50%;
  left: 50%;
  width: 4px;
  height: calc(50% + 1px);
  background: ${({theme}) => theme.palette[10]};
  transform: translateX(-50%) rotate(180deg);
  transform-origin: 50% 0;

  &::before {
    content: "";
    position: absolute;
    inset: 0;
    background: ${({theme}) => theme.palette[10]};
    transform: rotate(var(--quota-rotation, 0deg));
    transform-origin: 50% 0;
  }

  @media screen and (max-width: 768px) {
    width: 2px;
  }
`
